import { render, staticRenderFns } from "./BrokerageFeeWarning.vue?vue&type=template&id=5f8865ee&scoped=true&"
import script from "./BrokerageFeeWarning.vue?vue&type=script&lang=ts&"
export * from "./BrokerageFeeWarning.vue?vue&type=script&lang=ts&"
import style0 from "./BrokerageFeeWarning.vue?vue&type=style&index=0&id=5f8865ee&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8865ee",
  null
  
)

export default component.exports